module.exports = __webpack_public_path__ + "img/mx_insurama.cf83ca45.png";